import { render } from "./addpayment.vue?vue&type=template&id=2cc80bf1"
import script from "./addpayment.vue?vue&type=script&lang=js"
export * from "./addpayment.vue?vue&type=script&lang=js"

import "./addpayment.vue?vue&type=style&index=0&id=2cc80bf1&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__